import React, { ReactNode } from 'react'
import { Absolute } from '../bases/Absolute'
import { Center } from '../bases/Center'
import { Clickable } from '../bases/Clickable'

type Props = {
  type?: ButtonType
  size?: ButtonSize
  loading?: boolean
  children?: ReactNode
  onClick?: () => void
  disabled?: boolean
}

export const PinkNeonButton: React.FC<Props> = ({
  type = 'Default',
  size = 'M',
  disabled,
  onClick,
  loading = false,
  children,
}) => {
  return (
    <Clickable
      className={`items-center justify-center overflow-hidden rounded-full border-[3px]
      ${ButtonStyle[type]}
      ${ButtonDisabledStyle[type]}
      ${ButtonHeight[size]}
    `}
      disabled={disabled}
      onClick={onClick}
    >
      <Center
        className={`
          h-full w-full
          ${ButtonInnerStyle[type]}
          ${ButtonXPadding[size]}
          ${disabled ? 'shadow-transparent' : ''}
        `}
      >
        <Center
          className={`
            h-full w-full font-bold text-white
            ${ButtonTextSize[size]}
            ${disabled && type !== 'Selected' ? 'text-neutral-500' : 'text-white'}
            ${loading ? 'opacity-0' : ''}
          `}
        >
          {children}
        </Center>
        {loading ? (
          <Absolute>
            <Loading />
          </Absolute>
        ) : null}
      </Center>
    </Clickable>
  )
}

type ButtonType = 'Default' | 'Sub' | 'Selected'
type ButtonSize = 'S' | 'M'
const ButtonHeight: Record<ButtonSize, string> = {
  M: 'h-10',
  S: 'h-8',
}
const ButtonXPadding: Record<ButtonSize, string> = {
  M: 'px-8',
  S: 'px-5',
}

const ButtonStyle: Record<ButtonType, string> = {
  Default: 'border-[#FFCBF1] shadow-pink hover:bg-akiverse-pink',
  Sub: 'border-akiverse-pink  hover:bg-akiverse-pink',
  Selected: 'bg-akiverse-pink/50 border-akiverse-pink',
}

const ButtonDisabledStyle: Record<ButtonType, string> = {
  Default: 'disabled:border-neutral-500 disabled:shadow-none disabled:bg-opacity-0',
  Sub: 'disabled:border-neutral-500 disabled:shadow-none disabled:bg-opacity-0',
  Selected: 'disabled:bg-opacity-0',
}

const ButtonTextSize: Record<ButtonSize, string> = {
  S: 'text-sm',
  M: 'text-base',
}

const ButtonInnerStyle: Record<ButtonType, string> = {
  Default: 'shadow-pink-inset',
  Sub: '',
  Selected: '',
}

const Loading = () => (
  <div className="flex justify-center">
    <div className="h-6 w-6 animate-spin rounded-full border-[3px] border-white border-t-transparent border-opacity-70"></div>
  </div>
)
